export default __webpack_public_path__ + "static/media/cp_geo_ck.4b0176c0.svg";